import { UIIcon } from '../../../config/icons';
import { UIAside, UIAsideOptions } from '../aside';
import { onAttach, onDetach } from '../attach';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';

export interface UIDialogOptions extends UIAsideOptions {
    close?: boolean;
    classes?: UIClassesSpec;
}

export class UIDialog<T = boolean> extends UIAside<T> {
    protected content: HTMLElement;

    constructor(options: UIDialogOptions = {}) {
        super(['ui-dialog', options.classes], options);

        if(options.close) {
            const close = $el.ICON(UIIcon.XMARK, 'r-close');
            close.addEventListener('click', () => { this.dismiss(null); });
            this.ui_add(close);
        }

        this.ui_add(this.content = $el.DIV('ui-dialog-content'));
    }
}

export interface UIDocumentDialogOptions extends UIDialogOptions {
    page_title?: string;
}

export class UIDocumentDialog extends UIDialog {
    private _page_title?: string;
    private _saved_title?: string;
    iframe: HTMLIFrameElement;

    constructor(url: string, options: UIDocumentDialogOptions = {}) {
        options = Object.assign({ tap_close: true }, options);
        super(options);
        this.classList.add('ui-document-dialog');
        this.content.ui_add(this.iframe = $el.IFRAME(url));

        this._page_title = options.page_title;

        // TODO: make this part of UIDialog basic functionality
        onAttach(this, () => {
            if(this._page_title) {
                this._saved_title = document.title;
                document.title = this._page_title;
            }
        });

        onDetach(this, () => {
            if(this._saved_title) {
                document.title = this._saved_title;
            }
        });
    }
}
